const GRANT_FORM_FIELDS = ['endsAt', 'location', 'startsAt', 'type', 'user'];

export default GRANT_FORM_FIELDS;
